// lib/htlc/secretDerivation/index.ts
export * from './passkeyService';
